(function () {
  function getPlayButton(video) {
    var card = video.closest('[data-rng-gallery-card]');

    return card
      ? card.querySelector('[data-rng-gallery-play]')
      : null;
  }

  function pauseAllVideos(slider, resetVideos) {
    slider.querySelectorAll('video').forEach(function (video) {
      video.pause();

      if (resetVideos) {
        video.currentTime = 0;
      }

      var playBtn = getPlayButton(video);

      if (playBtn) {
        playBtn.classList.remove('is-hidden');
      }
    });
  }

  function pauseOtherVideos(slider, currentVideo) {
    slider.querySelectorAll('video').forEach(function (video) {
      if (video === currentVideo) return;

      video.pause();
      video.currentTime = 0;

      var playBtn = getPlayButton(video);

      if (playBtn) {
        playBtn.classList.remove('is-hidden');
      }
    });
  }

  function toggleVideo(slider, video) {
    if (!video) return;

    var playBtn = getPlayButton(video);

    if (video.paused || video.ended) {
      pauseOtherVideos(slider, video);

      video.muted = false;

      video
        .play()
        .then(function () {
          if (playBtn) {
            playBtn.classList.add('is-hidden');
          }
        })
        .catch(function () {
          if (playBtn) {
            playBtn.classList.remove('is-hidden');
          }
        });
    } else {
      video.pause();

      if (playBtn) {
        playBtn.classList.remove('is-hidden');
      }
    }
  }

  function bindVideoControls(slider) {
    slider
      .querySelectorAll('[data-rng-gallery-card]')
      .forEach(function (card) {
        var playBtn = card.querySelector('[data-rng-gallery-play]');
        var video = card.querySelector('video');

        if (!video) return;

        if (playBtn) {
          playBtn.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            toggleVideo(slider, video);
          });
        }

        video.addEventListener('play', function () {
          if (playBtn) {
            playBtn.classList.add('is-hidden');
          }
        });

        video.addEventListener('pause', function () {
          if (playBtn) {
            playBtn.classList.remove('is-hidden');
          }
        });

        video.addEventListener('ended', function () {
          if (playBtn) {
            playBtn.classList.remove('is-hidden');
          }
        });
      });
  }

  function getActiveSlide(slider) {
    return slider.querySelector('.swiper-slide-active');
  }

  function getActiveVideo(slider) {
    var activeSlide = getActiveSlide(slider);

    return activeSlide
      ? activeSlide.querySelector('video')
      : null;
  }

  function getCursorAction(clientX, slider) {
    var activeSlide = getActiveSlide(slider);

    if (!activeSlide) {
      var sliderRect = slider.getBoundingClientRect();
      var sliderCenter = sliderRect.left + sliderRect.width / 2;

      return clientX < sliderCenter ? 'prev' : 'next';
    }

    var activeRect = activeSlide.getBoundingClientRect();

    if (clientX < activeRect.left) {
      return 'prev';
    }

    if (clientX > activeRect.right) {
      return 'next';
    }

    return 'video';
  }

  function bindGalleryNavigation(slider, swiper) {
    var wrap = slider.closest('[data-rng-gallery-wrap]');

    if (!wrap) return;

    var cursor = wrap.querySelector('[data-rng-gallery-cursor]');

    var cursorPrev = cursor
      ? cursor.querySelector('[data-rng-gallery-cursor-prev]')
      : null;

    var cursorNext = cursor
      ? cursor.querySelector('[data-rng-gallery-cursor-next]')
      : null;

    var cursorPlay = cursor
      ? cursor.querySelector('[data-rng-gallery-cursor-play]')
      : null;

    var cursorPause = cursor
      ? cursor.querySelector('[data-rng-gallery-cursor-pause]')
      : null;

    var isFinePointer = window.matchMedia('(pointer: fine)').matches;
    var pointerDown = null;
    var lastPointerEvent = null;

    function hideAllIcons() {
      if (cursorPrev) cursorPrev.hidden = true;
      if (cursorNext) cursorNext.hidden = true;
      if (cursorPlay) cursorPlay.hidden = true;
      if (cursorPause) cursorPause.hidden = true;
    }

    function updateCursorIcon(action) {
      hideAllIcons();

      if (action === 'prev') {
        if (cursorPrev) {
          cursorPrev.hidden = false;
        }

        return;
      }

      if (action === 'next') {
        if (cursorNext) {
          cursorNext.hidden = false;
        }

        return;
      }

      if (action === 'video') {
        var activeVideo = getActiveVideo(slider);

        if (
          activeVideo &&
          !activeVideo.paused &&
          !activeVideo.ended
        ) {
          if (cursorPause) {
            cursorPause.hidden = false;
          }
        } else {
          if (cursorPlay) {
            cursorPlay.hidden = false;
          }
        }
      }
    }

    function updateCursor(event) {
      if (!cursor) return;

      lastPointerEvent = event;

      var action = getCursorAction(event.clientX, slider);

      cursor.style.left = event.clientX + 'px';
      cursor.style.top = event.clientY + 'px';
      cursor.dataset.action = action;

      updateCursorIcon(action);
      cursor.classList.add('is-visible');
    }

    function hideCursor() {
      if (!cursor) return;

      cursor.classList.remove('is-visible');
      lastPointerEvent = null;
    }

    function refreshCursor() {
      if (!lastPointerEvent) return;

      updateCursor(lastPointerEvent);
    }

    if (isFinePointer && cursor) {
      slider.addEventListener('mouseenter', updateCursor);
      slider.addEventListener('mousemove', updateCursor);
      slider.addEventListener('mouseleave', hideCursor);
    }

    slider.querySelectorAll('video').forEach(function (video) {
      video.addEventListener('play', refreshCursor);
      video.addEventListener('pause', refreshCursor);
      video.addEventListener('ended', refreshCursor);
    });

    slider.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;

      pointerDown = {
        x: event.clientX,
        y: event.clientY
      };
    });

    slider.addEventListener('pointerup', function (event) {
      if (!pointerDown || event.button !== 0) return;

      var deltaX = Math.abs(event.clientX - pointerDown.x);
      var deltaY = Math.abs(event.clientY - pointerDown.y);

      pointerDown = null;

      if (deltaX > 8 || deltaY > 8) return;

      if (
        event.target.closest('a') ||
        event.target.closest('[data-rng-gallery-play]')
      ) {
        return;
      }

      var action = getCursorAction(event.clientX, slider);

      if (action === 'prev') {
        swiper.slidePrev();
        return;
      }

      if (action === 'next') {
        swiper.slideNext();
        return;
      }

      if (action === 'video') {
        var activeVideo = getActiveVideo(slider);

        if (activeVideo) {
          toggleVideo(slider, activeVideo);
          refreshCursor();
        }
      }
    });
  }

  function initGallerySliders() {
    if (typeof Swiper === 'undefined') return;

    document
      .querySelectorAll('[data-rng-gallery-slider]')
      .forEach(function (slider) {
        if (slider.dataset.initialized === 'true') return;

        bindVideoControls(slider);

        var isFinePointer =
          window.matchMedia('(pointer: fine)').matches;

        var swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 20,
          loop: true,
          autoHeight: false,
          speed: 500,
          grabCursor: !isFinePointer,

          breakpoints: {
            1024: {
              spaceBetween: 25
            }
          },

          on: {
            slideChange: function () {
              pauseAllVideos(slider, true);
            }
          }
        });

        bindGalleryNavigation(slider, swiper);

        slider.dataset.initialized = 'true';
        slider.swiperInstance = swiper;
      });
  }

  function boot() {
    if (typeof Swiper !== 'undefined') {
      initGallerySliders();
      return;
    }

    var attempts = 0;

    var interval = window.setInterval(function () {
      attempts += 1;

      if (typeof Swiper !== 'undefined') {
        window.clearInterval(interval);
        initGallerySliders();
      } else if (attempts > 50) {
        window.clearInterval(interval);
      }
    }, 100);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();